import {CreateSessionFn} from "./types";

export class SessionManager {
  private currentSessionId: string | null = null;
  private readonly createSession: CreateSessionFn;

  constructor(createSession: CreateSessionFn) {
    this.createSession = createSession;
  }

  public get sessionId(): string | null {
    return this.currentSessionId;
  }

  public invalidate(): void {
    this.currentSessionId = null;
  }

  public async getOrCreate(payload: any): Promise<{ session_id: string; chat_id?: string }> {
    if (this.currentSessionId) {
      return { session_id: this.currentSessionId };
    }
    const data = await this.createSession(payload);
    this.currentSessionId = data.session_id;
    return data;
  }
}